import React, { Component } from 'react';
import { Spin } from 'antd';
import Title from '../Components/Title';
import compareFn from '../../Components/compareFn';
import TableC from '../../../../basicElement/TableC';
import EditableCell from '../../../../basicElement/EditableCell';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';

class Total extends Component {
    state = {
        data: [
            { total: '总计', price: '32000', siteNum: '20', period: '3' },
        ],
        prevData: [],
        loading: false,
        canEdit: false,
    }

    componentDidMount() {
        const { editable } = this.props;
        this.setState({ canEdit: editable });
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.editable && this.props.editable) {
            this.setState({ canEdit: true });
        }
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.site.queryInvestigationSiteFee)
        .then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }
    
    getColumns = () => {
        const { mode, names } = this.props;
        const { data, prevData, canEdit } = this.state;
        const columns = [{
            title: names.tc,
            dataIndex: 'total',
            key: 'total',
            width: 500,
        }, {
            title: names.comments,
            dataIndex: 'comments',
            key: 'comments',
            render: (text, record, index) => {
                if (mode === 'compare') {
                    return compareFn(prevData, data, 'comments');
                } else {
                    return (
                        <div className="inlineBlock">
                            <EditableCell type="Input" editable={canEdit} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'comments')} />
                        </div>
                    );
                }
            }
        }];
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;
        this.setState({ data: [...data] });
    }

    save = (canEdit) => {
        if (!canEdit) {
            this.setState({ canEdit: true });
        } else {
            this.setState({ canEdit: false });
            // this.props.hasChange(false);
        }
    }

    render() {
        const { title, editable } = this.props;
        const { data, loading, canEdit } = this.state;
        return (
            <Spin spinning={loading}>
                <Title title={title} editable={editable} canEdit={canEdit} save={this.save} />
                <div style={{ paddingLeft: 10 }}>
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="quotation_crc"
                    />
                </div>
            </Spin>
        );
    }
}

export default Total;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Table/Total.js